<script setup lang="ts">
import { ref, computed, onMounted } from 'vue';
import iconset from '../../../../../core/app/assets/fontawesome/iconset.json';
// import fontawesome from '../../../assets/fontawesome/icons.json';

const model = defineModel<string>();
const props = withDefaults(defineProps<{
    name: string;
    disabled?: boolean;
}>(), {
    disabled: false
});
const query = ref('');
const display = ref('');
const groups = computed(() => [...new Set(Object.values(iconset).selectMany(p => p.s).toArray())].map(p => ({ value: p, text: p.upperFirst() })));
const icons = computed(() =>
{
    return Object.entries(iconset)
        .where(([_, value]) => value.s.includes(group.value))
        .where(([key, _]) => query.value ? key.includes(query.value) : true)
        .take(100)
        .select(([key, _]) => ({
            value: key,
            text: key
        }))
        .toArray();
});
const group = computed({
    get: () => model.value?.split(' ').select(p => p.replace('fa-', '')).where(p => groups.value.where(q => q.value == p).any()).first() ?? 'regular',
    set: (value) =>
    {
        const currentIcon = icon.value;

        if (currentIcon == null || currentIcon === '')
        {
            model.value = '';

            return;
        }

        model.value = `fa-${value} fa-${currentIcon}`;
    }
});
const icon = computed({
    get: () =>
    {
        if (!model.value?.trim()) return null;

        return model.value.split(' ').filter(Boolean).last()?.replace('fa-', '') ?? null;
    },
    set: (value) =>
    {
        if (value == null || value === '')
        {
            model.value = '';

            return;
        }

        model.value = `fa-${group.value} fa-${value}`;
    }
});

onMounted(() =>
{
    // Generator pliku iconset.json z pliku "metadata/icons.json" z zestawu "fontawesome-pro-x.x.x-web.zip"

    // const result = Object.entries(fontawesome)
    //     .map(([name, value]) =>
    //     {
    //         return {name, unicode: value.unicode, styles: value.styles};
    //     })
    //     .record(p => p.name, p => ({ c: p.unicode, s: p.styles }));

    // console.log(JSON.stringify(result));

    // Rezultat należy skopiować z konsoli i zapisać w pliku "assets/fontawesome/iconset.json"
});
</script>

<template>
    <div class="d-flex">
        <div class="d-flex align-items-center bg-body-tertiary border border-end-0 rounded-start px-1 min-w-8">
            <i v-if="icon" :class="`fa-2x fa-fw fa-${group} fa-${icon}`" aria-hidden="true" />
        </div>
        <div class="w-100">
            <IdeoComboBox
                v-model="icon"
                v-model:display="display"
                v-model:query="query"
                :disabled="props.disabled"
                toggle-class="rounded-start-0"
                :ignore-click-outside-selectors="[]"
                :name="props.name"
                :footer="false"
                :options="icons"
            >
                <template #label="{ option }">
                    <div class="d-flex align-items-center">
                        <span class="w-100">{{ option.text }}</span>
                        <i v-if="option.value" :class="`fa-fw fa-${group} fa-${option.value}`" />
                    </div>
                </template>
                <template #footer>
                    <div class="border-top pt-2 ps-1">
                        <IdeoFormRadioGroup v-model="group" :options="groups" stacked :columns="2" />
                    </div>
                </template>
            </IdeoComboBox>
        </div>
    </div>
</template>
